import React, { createContext, useContext } from "react";

export const AppBarInfoContext = createContext<any>(null);

export function useAppBarInfo() {
  return useContext(AppBarInfoContext);
}
